export default __webpack_public_path__ + "67e013e98dfc7d7518a686fd234e29aa.svg";